import utils from '@/mixins/utils.js'

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    callback: (item) => {
      let idade = `${utils.methods.formatDate(item.dt_nascimento)} (${
        item.idade
      } ${item.idade > 1 ? 'anos' : 'ano'})`
      return idade
    },
  },
  Mãe: 'no_mae',
  Atendimento: {
    callback: (item) => {
      let dados = JSON.parse(item.dados)
      return dados != null ? utils.methods.formatDate(dados.dt_atendimento) : ''
    },
  },
}

export const infoHtml = ``
